import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { CreditFormModel } from "@tFissco/ApiModels";

import { addCreditFormFields } from "@tFissco/Services/SubmitCreditFormService";

type HandlerType = ApiHandler<
    CreditFormModel & HasOnSuccess & HasOnError<string>,
    CreditFormModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SubmitFormDataToApi: HandlerType = async props => {
    try {
        const result = await addCreditFormFields(props.parameter);
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
        }

        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SubmitFormDataToApi, ExecuteOnSuccessCallback];

const submitCreditFormData = createHandlerChainRunner(chain, "SubmitCreditFormData");
export default submitCreditFormData;

